// extracted by mini-css-extract-plugin
module.exports = {"sm":"(min-width: 640px)","md":"(min-width: 768px)","xl":"(min-width: 1280px)","blog-article-header-title":"BlogHeader_blog-article-header-title__JHu50"};